<template>
  <div v-if="markerReady">
    <div v-for="(item, index) in markerList" :key="index">
      <GrowthMarker :item="item" :map="map" :show-content-index="showContentIndex" @showContent="showContent"></GrowthMarker>
    </div>
  </div>
</template>

<script>
import GrowthMarker from "@/views/TraceSource/GrowthMarker.vue";

export default {
  name: 'GrowthMarkerEntry',
  components: {GrowthMarker},
  props: {
    map: {
      required: true
    },
    markerList: {
      required: true
    },
  },
  data() {
    return {
      showContentIndex: 0,
      markerReady: false
    }
  },
  methods: {
    showContent(item) {
      this.showContentIndex = item.index
    }
  },
  mounted() {
    for (let i = 0; i < this.markerList.length; i++) {
      this.markerList[i].index = i
    }
    this.showContentIndex = 0
    this.markerReady = true
  }
}
</script>

<style scoped>

</style>